import type { MagicSearchBooking } from '@domain/magic-search';
import type { CompanyClubRoute } from '@hooks/use-open-company-club-route';
import { getBookingDetailsRoute } from '@utils/event-report/get-booking-details-route';

export const getBookingRoute = ({
  id,
  event,
  isNavigable,
  club,
  company,
}: MagicSearchBooking): CompanyClubRoute | null => {
  const clubSlug = club?.slug;
  if (!isNavigable || !clubSlug || !company) return null;
  const companyLegacyId = String(company.legacyId);

  return {
    companyLegacyId,
    clubSlug,
    path: getBookingDetailsRoute({ bookingId: id, eventId: event.id, clubSlug, companyLegacyId }),
  };
};
